import { gql } from '@apollo/client';

const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    currentUser {
      Id
      Email
      Name
      FirstName
      SystemRole {
        Id
        DisplayName
      }
      SupplementalRole {
        Id
        DisplayName
      }
      Privileges
      Tier
      LicensedOrgId
      LicensedOrgUnitId
      AllowedOrgIds
      AllowedOrgUnitIds
      IsSuperUser
      IsDeactivated
    }
  }
`;

export default GET_CURRENT_USER;
